import { render } from "./NavBar.vue?vue&type=template&id=d365f4ce&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=d365f4ce&lang=sass&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d365f4ce"]])

export default __exports__